import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { JobLogbook } from 'src/app/models/my-work/job-logbook.model';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { NavigationActionButton } from '../../navigation-bar/models/navigation-action-button.model';
import { BinderWizardDetails } from 'src/app/models/binder/binder-wizard-details.model';
import { BinderDetails } from 'src/app/models/binder/binder-details.model';

@Component({
	selector: 'digital-logbook',
	templateUrl: './digital-logbook.component.html',
	styleUrls: ['./digital-logbook.component.scss', '../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss', '../../stylesheets/job-inputs.scss', '../../stylesheets/job-contacts.scss']
})
export class DigitalLogbookComponent implements OnInit, AfterViewInit, OnDestroy {

	public digitalLogbooks: JobLogbook[];
	public readonly moment = moment;
	public binderDetails: BinderDetails;

	public returnUrl: string = null;

	public navigationBarActions: Map<string, NavigationActionButton>;

	constructor(
		private router: Router,
		private route: ActivatedRoute
	) {
		this.digitalLogbooks = this.route.snapshot.data.digitalLogbooks;
		this.binderDetails = this.route.snapshot.data.binderDetails;
	}

	ngOnInit(): void {
		GlobalSettingsService.isSecondaryLoaderLoading = false;

		this.navigationBarActions = GlobalSettingsService.navigationBarActions;

		GlobalSettingsService.navigationBarActions = new Map<string, NavigationActionButton>();
		this.injectActionButtons();
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
	}

	ngOnDestroy(): void {
		GlobalSettingsService.navigationBarActions.delete('return_to_binder');
	}

	public injectActionButtons(): void {

		GlobalSettingsService.navigationBarActions.set(
			'return_to_binder',
			{
				action: ( () => {
					this.router.navigate(
					['../'],
					{relativeTo: this.route}
					);
				}),
				text: 'Binder',
				isInDropdownMenu: false,
				isTextOnlyShownInDropdown: true,
				icon: 'qr_binder_return',
				isCustomSvgIcon: true,
				listOrder: 0
			});
	}
}
